import { FOfferType, isSuburban } from '../../../../../../JsonQuery';
import { EMetroTravelType } from '../../../../types/jsonQuery';

export const getTravelTypeByOfferType = (offerType: FOfferType) =>
  isSuburban(offerType) ? EMetroTravelType.MapTransport : EMetroTravelType.MapFoot;
